import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { useLocation } from '@reach/router';

const darkIconLinks = [
	'/employee-nursery/',
	'/employee-cycling/',
	'/employer-nursery/',
	'/employer-cycling/',
	'/employer-cycling/get-started/',
	'/provider-cycling/',
	'/provider-nursery/',
	'/about-us/',
	'/b-corp/',
	'/iso/',
	'/tell-parents/',
	'/tell-customers/',
	'/faqs/',
	'/cookie-policy/',
	'/terms-and-conditions/',
	'/privacy-policy/',
	'/workplace-nursery-compliance/',
	'/workplace-nursery/service-reliability/',
	'/gogeta-ai-instructions/',
	'/',
];

const useHeaderMenuIconColor = (): string => {
	const theme = useTheme();
	const [color, setColor] = useState(theme.colors.wheat);
	const location = useLocation();
	useEffect(() => {
		if (darkIconLinks.includes(location.pathname) || location.pathname.includes('/blog/')) {
			setColor(theme.colors.darkText);
		} else {
			setColor(theme.colors.wheat);
		}
	}, [location, theme.colors]);

	return color;
};

export default useHeaderMenuIconColor;
